import { render, staticRenderFns } from "./ChatWithExhibitor.vue?vue&type=template&id=d85efe14&"
import script from "./ChatWithExhibitor.vue?vue&type=script&lang=js&"
export * from "./ChatWithExhibitor.vue?vue&type=script&lang=js&"
import style0 from "./ChatWithExhibitor.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports